import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

// Config PÚBLICA do Firebase Web (não é segredo — apiKey identifica o projeto,
// não autoriza). Injetada via env do Vite (VITE_*). Nenhum segredo SP-API/AWS
// pode entrar no bundle (invariante CLAUDE.md / SDD §5).
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

export const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
